export default __webpack_public_path__ + "static/IN-9408-vs-IN-9008_resTestBig-f733e5bdaca43ac908bd812d22321cd1.webp";